import React from 'react'

import { Typography } from '@material-ui/core'
import { styled, withStyles } from '@material-ui/core/styles'

import { TrackButton } from 'artkive/components/Tracker'

export const Wrapper = styled('div')(({ theme: { colors, breakpoints, spacing }, bgColor }) => ({
  backgroundColor: bgColor || colors.violet[700],
  padding: '15px 0',
  position: 'sticky',
  top: 54,
  zIndex: 1090,
  [breakpoints.up('md')]: {
    top: 64,
    padding: spacing(3, 0),
  },
}))

export const Track = withStyles({
  root: {
    display: 'flex',
    width: 'max-content',
    animation: '$springSaleScroll 70s linear infinite',
  },
  '@keyframes springSaleScroll': {
    from: {
      transform: 'translateX(0)',
    },
    to: {
      transform: 'translateX(-50%)',
    },
  },
})(({ classes, children }) => <div className={classes.root}>{children}</div>)

export const TrackItemLabel = styled(Typography)(({ theme: { colors }, textColor }) => ({
  color: textColor || colors.white,
  display: 'inline-flex',
  alignItems: 'center',
  marginRight: 100,
  flexShrink: 0,
  fontWeight: 600,
}))

export const ItemSeparator = styled('span')(({ theme: { spacing } }) => ({
  '&::before': {
    content: '"|"',
    display: 'inline-block',
    width: 1,
    margin: spacing(0, 1),
  },
}))

export const SaleLink = styled(TrackButton)(({ theme: { colors, spacing }, textColor }) => ({
  color: textColor || colors.white,
  textTransform: 'none',
  minWidth: 'auto',
  padding: 0,
  margin: spacing(0, 0.5),
  textDecoration: 'underline',
  fontWeight: 700,
  lineHeight: 'inherit',
  fontSize: 'inherit',
  '&:hover': {
    backgroundColor: 'transparent',
  },
}))
